<template>
  <div>
    <nav class="navbar navbar-dark bg-dark sticky-top">
      <div class="container-fluid">

        <b-navbar-nav class="navbar-nav pe-3">
          <b-nav-item :to="routeLink" class="nav-item">
            <h5 id="offcanvasDarkNavbarLabel" class="offcanvas-title">
              <b> COMPLIANCE </b>
            </h5>
          </b-nav-item>
        </b-navbar-nav>

        <div class="flex-grow-1"></div>

        <Logout-button/>

        <button aria-controls="offcanvasDarkNavbar" aria-label="Toggle navigation" class="navbar-toggler"
                data-bs-target="#offcanvasDarkNavbar" data-bs-toggle="offcanvas"
                type="button">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div id="offcanvasDarkNavbar" aria-labelledby="offcanvasDarkNavbarLabel" class="offcanvas offcanvas-end text-bg-dark"
             data-bs-backdrop="false" data-bs-scroll="true" tabindex="-1">
          <div class="offcanvas-header">

            <b-navbar-nav
              v-permission="'configuracion-vista'"
              class="navbar-nav justify-content-end flex-grow-1 pe-3">
              <b-nav-item :to="{ name: 'Setting' }" class="nav-item">
                <h5 id="offcanvasConfigButton" class="offcanvas-title">
                  <b-icon class="icone-tools" icon="tools"></b-icon>
                  Configuraciones
                </h5>

              </b-nav-item>
            </b-navbar-nav>

            <button aria-label="Close" class="btn-close btn-close-white" data-bs-dismiss="offcanvas"
                    type="button">
            </button>

          </div>

          <div class="offcanvas-body">
            <b-navbar-nav class="navbar-nav justify-content-end flex-grow-1 pe-3">
              <b-nav-item
                v-permission="'usuarios-vista'"
                :to="{ name: 'UserMaintainer' }" class="nav-item">
                <b-icon class="icone-people" icon="people"></b-icon>
                Mantenedor de Usuarios
              </b-nav-item>

              <b-nav-item
                v-permission="'documentos-vista'"
                :to="{ name: 'DocumentRepository' }"
                class="nav-item">
                <b-icon class="icone-files" icon="files"></b-icon>
                Repositorio de Documentos
              </b-nav-item>

              <b-nav-item
                v-permission="'reuniones-vista'"
                :to="{ name: 'Meeting' }"
                class="nav-item">
                <b-icon class="icone-Meet" icon="calendar2-week"></b-icon>
                Reuniones
              </b-nav-item>

              <b-nav-item 
                v-permission="'declaraciones-vista'"
                :to="{ name: 'Statements' }"
                class="nav-item">
                <b-icon class="icone-statements" icon="megaphone"></b-icon>
                Declaraciones
              </b-nav-item>

              <b-nav-item
                  v-permission="'empresas-vista'"
                  class="nav-item" :to="{ name: 'ManagedCompanies'}">
                  <b-icon icon="card-checklist"></b-icon>
                  Empresas Administradas
              </b-nav-item>

              <!-- <b-nav-item class="nav-item" :to="{ name: 'Suppliers' }">
                  <b-icon icon="box-seam" class="icone-suppliers"></b-icon>
                  Proveedores
              </b-nav-item> -->

              <!-- <b-nav-item class="nav-item" :to="{ name: 'Rrhh' }">
                  <b-icon icon="person-fill" class="icone-rrhh"></b-icon>
                  RRHH
              </b-nav-item> -->

              <!-- <b-nav-item class="nav-item" :to="{ name: 'Briefcase' }">
                  <b-icon icon="briefcase" class="icone-statements"></b-icon>
                  Contratista
              </b-nav-item> -->

              <b-nav-item :to="{ name: 'Denounce' }" class="nav-item">
                <b-icon class="icone-statements" icon="mailbox"></b-icon>
                Canal de Denuncia
              </b-nav-item>

              <b-nav-item
                v-permission="'capacitaciones-vista'"
                :to="{name: 'CoursesContent'}"
                class="nav-item">
                <b-icon class="icone-statements" icon="book-half"></b-icon>
                Capacitaciones
              </b-nav-item>
            </b-navbar-nav>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>

import LogoutButton from '@/components/shared/navbar/Logout-button.vue'
import {mapGetters} from 'vuex'

export default {
  name: 'NavigationBar',

  components: {
    LogoutButton
  },

  computed: {
    ...mapGetters(['getHomePath']),

    routeLink() {
      return  `/${this.getHomePath}`
    }

  }
}
</script>

<style scoped>
.icone-tools {
  color: #da9c96;
}

.icone-people {
  color: #95d5c7;
}

.icone-files {
  color: #9b95d5;
}

.icone-Meet {
  color: #c0d357;
}

.icone-statements {
  color: #5772d3;
}

.icone-suppliers {
  color: #a896da;
}
</style>
